import countries from "@/components/Util/countries.json";

const defaultSortOptions = { sensitivity: "base" };

export const sortCountriesByName = (countryList = countries) => {
  return [...(countryList || [])].sort((a, b) =>
    (a?.name || "").localeCompare(b?.name || "", "en", defaultSortOptions)
  );
};

export default sortCountriesByName;
